// extracted by mini-css-extract-plugin
export const sideBar = "sideBar-module--sideBar--8a-3N";
export const social = "sideBar-module--social--_ZNIJ";